import { useFragment } from "@apollo/client";
import toast from "react-hot-toast";
import { useClientAccessToken } from "@/contexts/clientAccessTokenContext";
import {
  ClientInterestInPaymentPlansFragment,
  ClientInterestInPaymentPlansFragmentDoc,
} from "@/graphql/fragments/paymentPlans/clientInterestInPaymentPlans.graphql.types";
import { useUpdateClientPaymentPlansInterestMutation } from "@/graphql/mutations/paymentPlans/updateClientPaymentPlansInterest.graphql.types";
import useErrorLogger from "@/utils/useErrorLogger";

export default function useUpdateClientPaymentPlansInterest(
  clientId: string,
  withToast: boolean = false
) {
  const logError = useErrorLogger();
  const [updateClientInterest] = useUpdateClientPaymentPlansInterestMutation();
  const { getTokenContext } = useClientAccessToken();

  const { data } = useFragment<ClientInterestInPaymentPlansFragment>({
    fragment: ClientInterestInPaymentPlansFragmentDoc,
    fragmentName: "ClientInterestInPaymentPlans",
    from: {
      __typename: "client",
      id: clientId,
    },
  });

  const handleMarkAsInterested = async () => {
    try {
      if (data && !data.interestedInPaymentPlans) {
        await updateClientInterest({
          variables: {
            clientId,
            interestedInPaymentPlans: true,
          },
          ...getTokenContext(),
        });
      }
      if (withToast) {
        toast.success(
          "Great! We'll let your provider know to bring this up in the appointment."
        );
      }
    } catch (error) {
      logError(error);
    }
  };

  return { handleMarkAsInterested };
}
